import { FC, memo } from 'react';
import { ImageX } from '@bridebook/ui';
import { Text } from '@bridebook/aura';
import { Link } from '@bridebook/web/app-shared/components/link/link';

interface IProps {
  slide: {
    title: string;
    imageUrl: string;
  };
  href: string;
}

const SearchSupplierCard: FC<IProps> = ({ slide: { title, imageUrl }, href }) => (
  <Link href={href}>
    <div className="w-full">
      <div className="relative h-[176px] w-[193px] overflow-hidden rounded-2xl">
        <ImageX src={imageUrl} w={193} h={176} />
        <div className="absolute inset-0 z-10 bg-linear-to-b from-black/0 to-black/80 opacity-40" />
        <Text as="h5" className="absolute right-4 bottom-4 left-4 z-10 m-0 text-[18px] text-white">
          {title}
        </Text>
      </div>
    </div>
  </Link>
);

export default memo(SearchSupplierCard);
